export interface VideoArticle {
  id: number;
  title: string;
  slug: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  likes: number;
  author: string;
  authorAvatar: string;
  description: string;
  contentHtml: string;
  tags: string[];
  createdAt: string;
  featured: boolean;
}

export const videos: VideoArticle[] = [
  {
    id: 1,
    title: '这个魔术太神奇了！路人看完直接懵了',
    slug: 'magic-trick-street',
    category: 'gaoxiao',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20brightly%20lit%20street%20scene%20with%20a%20magician%20performing%20a%20card%20trick%20for%20surprised%20bystanders%2C%20warm%20sunny%20day%2C%20vibrant%20colors%2C%20modern%20urban%20setting%2C%20lifestyle%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20expressive%20faces&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '02:35',
    views: 1285000,
    likes: 98200,
    author: '魔术师小明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20in%20casual%20streetwear%20with%20a%20friendly%20smile%2C%20simple%20studio%20portrait%2C%20clean%20cream%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    description: '街头魔术挑战，路人反应笑翻全场！',
    contentHtml: '<p>今天在街头做了一组近景魔术挑战，路人们的反应简直太搞笑了！</p><p>第一个魔术是消失的硬币，我让一位阿姨帮忙握住硬币，结果硬币凭空消失了，阿姨的表情简直不敢相信自己的眼睛。</p><p>第二个是纸牌魔术，我让一位小哥随机抽一张牌，然后从他的手机壳后面把牌变了出来。小哥当场愣住三秒钟，然后疯狂大笑。</p><p>最精彩的是最后的心灵感应魔术，我让一对情侣参与，预测他们心中想的东西，结果完全命中，两人满脸震惊。</p><p>街头魔术的魅力就在于真实的反应，没有任何彩排，每一个笑容和惊讶都是最真实的。喜欢的朋友记得点赞关注，下次带更多好玩的内容给大家！</p>',
    tags: ['魔术', '街头', '搞笑', '路人反应'],
    createdAt: '2026-08-06',
    featured: true,
  },
  {
    id: 2,
    title: '深夜食堂｜五分钟搞定一碗灵魂拌面',
    slug: 'midnight-noodles',
    category: 'meishi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20steaming%20bowl%20of%20Chinese%20handmade%20noodles%20with%20chili%20oil%20and%20green%20onions%20on%20a%20wooden%20table%2C%20warm%20ambient%20kitchen%20lighting%2C%20steam%20rising%20from%20the%20bowl%2C%20cozy%20night%20atmosphere%2C%20food%20photography%20style%2C%20rich%20textures%2C%20appetizing%20red%20chili%20oil%20glistening&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '05:12',
    views: 896000,
    likes: 75400,
    author: '厨房日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20wearing%20a%20simple%20apron%20in%20a%20bright%20kitchen%2C%20warm%20smile%2C%20clean%20cream%20background%2C%20professional%20portrait%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    description: '深夜肚子饿？五分钟搞定一碗灵魂拌面，简单又满足！',
    contentHtml: '<p>夜深了，肚子开始咕咕叫？来一碗灵魂拌面吧，五分钟就搞定！</p><p>食材准备：挂面一把、蒜末、葱花、生抽、老抽、辣椒油、花椒油、醋、芝麻酱。</p><p>第一步：水开下面，煮三分钟捞出过凉水，这样面条更筋道。</p><p>第二步：调灵魂酱汁。碗里放两勺生抽、一勺老抽、一勺醋、一勺辣椒油、半勺花椒油、一勺芝麻酱，搅拌均匀。</p><p>第三步：把沥干的面条倒入碗中，撒上葱花和芝麻，淋上热油激发香味，搅拌均匀即可。</p><p>这一碗拌面香气四溢，面条裹满酱汁，一口下去满满的幸福感。深夜的灵魂慰藉就是这么简单！</p>',
    tags: ['美食', '拌面', '深夜食堂', '快手菜'],
    createdAt: '2026-08-05',
    featured: true,
  },
  {
    id: 3,
    title: '一人独居的周末日常｜治愈系慢生活Vlog',
    slug: 'solo-weekend-vlog',
    category: 'shenghuo',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cozy%20minimalist%20apartment%20living%20room%20with%20warm%20sunlight%20streaming%20through%20large%20windows%2C%20a%20cat%20sleeping%20on%20a%20soft%20sofa%2C%20potted%20plants%2C%20a%20cup%20of%20coffee%20on%20a%20wooden%20coffee%20table%2C%20peaceful%20atmosphere%2C%20lifestyle%20photography%2C%20soft%20cream%20and%20beige%20tones&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '08:20',
    views: 675000,
    likes: 62300,
    author: '小鹿的生活日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20with%20long%20hair%20in%20a%20cozy%20sweater%2C%20gentle%20smile%2C%20minimalist%20cream%20background%2C%20warm%20portrait%20photography%2C%20soft%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    description: '一个人的周末也可以很精彩，治愈系慢生活。',
    contentHtml: '<p>周六早上八点，阳光透过窗帘洒进房间，新的一天开始了。</p><p>起床后先给窗台上的绿植浇了水，看着它们生机勃勃的样子，自己的心情也跟着好起来。</p><p>早餐做了简单的牛油果吐司配一杯手冲咖啡，坐在窗边慢慢享用。窗外是城市的早晨，安静而美好。</p><p>上午去了附近的菜市场，买了新鲜的蔬菜水果。回来路上顺便在花店买了一束洋甘菊，放在客厅瞬间提升了整个空间的氛围。</p><p>下午窝在沙发上看了一部老电影，猫咪趴在腿上打呼噜，这种宁静的时光真的很治愈。</p><p>一个人的独居生活，不需要多么轰轰烈烈，平淡中的小确幸才是最真实的美好。</p>',
    tags: ['生活', 'Vlog', '独居', '治愈'],
    createdAt: '2026-08-04',
    featured: false,
  },
  {
    id: 4,
    title: '零基础吉他弹唱教学《晴天》｜三分钟学会',
    slug: 'guitar-tutorial-sunny',
    category: 'caiyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20acoustic%20guitar%20leaning%20against%20a%20cream%20wall%20with%20warm%20sunlight%20casting%20soft%20shadows%2C%20a%20guitar%20pick%20and%20music%20sheet%20nearby%2C%20minimalist%20composition%2C%20warm%20and%20inviting%20atmosphere%2C%20artistic%20photography%20style&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '03:45',
    views: 542000,
    likes: 48100,
    author: '吉他老师阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20holding%20a%20guitar%2C%20friendly%20expression%2C%20simple%20cream%20background%2C%20warm%20portrait%20lighting%2C%20casual%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
    description: '零基础也能学会！简单和弦弹唱《晴天》，一起感受音乐的魅力。',
    contentHtml: '<p>今天教大家用最简单的四个和弦弹唱周杰伦的《晴天》，零基础也能学会！</p><p>需要用到的和弦：C、G、Am、F。如果你觉得F和弦太难，可以先用简化版Fmaj7代替。</p><p>右手节奏型：下-下上-上下上（最简单的分解节奏）。</p><p>整首歌的和弦进行：C-G-Am-F 循环，副歌部分也是这个进行。</p><p>我给大家演示一遍慢速版的，跟着我的节奏来。注意换和弦的时机，提前做好准备，不要等到唱到那个字了才开始换。</p><p>练熟之后可以加快速度，找到原曲的感觉。希望大家都能学会这首经典的歌曲，记得交作业哦！</p>',
    tags: ['吉他', '教学', '晴天', '弹唱'],
    createdAt: '2026-08-03',
    featured: false,
  },
  {
    id: 5,
    title: '一个人的大理之旅｜苍山洱海间的慢时光',
    slug: 'dali-travel-vlog',
    category: 'lvxing',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Erhai%20Lake%20in%20Dali%20China%20with%20Cangshan%20mountains%20in%20the%20background%2C%20clear%20blue%20sky%2C%20traditional%20white%20buildings%20by%20the%20lake%2C%20golden%20sunset%20light%2C%20peaceful%20travel%20scene%2C%20wide%20landscape%20photography&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '12:30',
    views: 1200000,
    likes: 112000,
    author: '旅行者小杨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20traveler%20with%20a%20camera%20and%20backpack%2C%20outdoor%20portrait%2C%20friendly%20smile%2C%20warm%20natural%20lighting%2C%20simple%20background&width=100&height=100&seq=avatar-05&orientation=squarish',
    description: '苍山雪、洱海月，大理的每一帧都是风景。',
    contentHtml: '<p>终于来到了心心念念的大理！一出火车站就被这里的蓝天震撼了。</p><p>第一站去了洱海。租了一辆电动车环湖骑行，沿途的风光美得让人忘记时间。湛蓝的湖水倒映着苍山的雪顶，白族村落散落在湖畔，每一帧都像明信片。</p><p>下午去了喜洲古镇，尝了正宗的喜洲粑粑，外酥里软，满口留香。古镇的青石板路和白族建筑保留得很完整，走在其中仿佛穿越了时光。</p><p>傍晚在双廊找了一家海景民宿，坐在阳台上看日落，天空从橙红渐变到深紫，洱海的水面染上了金色，这一刻觉得所有的奔波都值得。</p><p>大理的魅力在于它的慢，不需要赶景点，随便找一家咖啡馆发呆一下午都是享受。</p>',
    tags: ['旅行', '大理', '洱海', 'Vlog'],
    createdAt: '2026-08-02',
    featured: true,
  },
  {
    id: 6,
    title: '2026年最值得关注的AI黑科技｜改变生活的十大应用',
    slug: 'ai-tech-2026',
    category: 'keji',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20futuristic%20minimalist%20tech%20workspace%20with%20holographic%20displays%20floating%20in%20mid%20air%2C%20clean%20white%20and%20warm%20gray%20aesthetic%2C%20soft%20ambient%20lighting%2C%20sleek%20modern%20design%2C%20concept%20photography%20style&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '06:55',
    views: 756000,
    likes: 68900,
    author: '科技探秘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20tech%20enthusiast%20wearing%20glasses%2C%20modern%20style%2C%20friendly%20expression%2C%20cream%20background%2C%20professional%20portrait&width=100&height=100&seq=avatar-06&orientation=squarish',
    description: '盘点2026年最让人惊艳的AI技术应用，有些已经走进日常生活！',
    contentHtml: '<p>2026年是AI技术爆发的一年，今天就给大家盘点十大已经走进我们生活的AI黑科技应用。</p><p>第一名：AI视频生成。现在你只需要输入一段文字描述，AI就能生成高质量的视频内容，短视频创作者的生产效率直接翻倍。</p><p>第二名：AI实时翻译耳机。戴上一副耳机就能实现几十种语言的实时翻译，出国旅游再也不用担心语言不通。</p><p>第三名：AI健康监测手环。不仅能监测心率、血氧，还能通过数据预测潜在的健康风险，提前预警。</p><p>第四到第十名还包括：AI智能家居中枢、AI教育辅导机器人、AI绘画工具、AI音乐创作、AI编程助手、AI无人配送车和AI智能农业系统。</p><p>这些技术不再只是概念，而是真实地改变着我们的生活方式。科技让生活更美好，不是一句口号。</p>',
    tags: ['科技', 'AI', '黑科技', '2026'],
    createdAt: '2026-08-01',
    featured: true,
  },
  {
    id: 7,
    title: '每天十分钟｜居家燃脂训练计划',
    slug: 'home-workout-10min',
    category: 'yundong',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20airy%20home%20fitness%20space%20with%20a%20yoga%20mat%20on%20a%20light%20wooden%20floor%2C%20dumbbells%20and%20a%20water%20bottle%20nearby%2C%20sunlight%20streaming%20through%20windows%2C%20minimalist%20clean%20aesthetic%2C%20fitness%20lifestyle%20photography&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '10:15',
    views: 910000,
    likes: 82300,
    author: '健身达人Leo',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20fit%20young%20Chinese%20man%20in%20sportswear%2C%20confident%20smile%2C%20cream%20background%2C%20fitness%20portrait%2C%20warm%20lighting&width=100&height=100&seq=avatar-07&orientation=squarish',
    description: '每天只需十分钟，在家就能高效燃脂，无需任何器械！',
    contentHtml: '<p>很多朋友说没时间去健身房，今天就教大家一套居家燃脂训练，每天只需十分钟，效果堪比跑步半小时！</p><p>动作一：开合跳 30秒。全身性热身动作，快速提升心率。</p><p>动作二：高抬腿 30秒。核心收紧，大腿尽量抬高，感受腹部的发力。</p><p>动作三：波比跳 30秒。这是燃脂之王，一个动作锻炼全身，做完保证暴汗。</p><p>动作四：登山跑 30秒。保持平板支撑姿势，交替提膝，锻炼核心和心肺。</p><p>动作五：深蹲跳 30秒。注意膝盖不要超过脚尖，落地缓冲。</p><p>五个动作循环两遍，中间休息30秒。坚持一个月，你会看到明显的变化！</p>',
    tags: ['运动', '健身', '燃脂', '居家锻炼'],
    createdAt: '2026-07-31',
    featured: false,
  },
  {
    id: 8,
    title: '我家猫主子的迷惑行为大赏｜看完笑喷',
    slug: 'cat-funny-moments',
    category: 'dongwu',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fluffy%20orange%20tabby%20cat%20making%20a%20funny%20surprised%20expression%20while%20sitting%20on%20a%20cream%20colored%20sofa%2C%20warm%20living%20room%20setting%2C%20soft%20natural%20light%2C%20adorable%20pet%20photography%2C%20playful%20mood&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '04:20',
    views: 2100000,
    likes: 198000,
    author: '铲屎官小美',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20with%20a%20cat%20on%20her%20lap%2C%20warm%20smile%2C%20cozy%20home%20setting%2C%20cream%20background%2C%20casual%20portrait&width=100&height=100&seq=avatar-08&orientation=squarish',
    description: '猫咪的迷惑行为永远看不腻，每一帧都是表情包！',
    contentHtml: '<p>养猫三年，我已经收集了满满一手机的猫咪迷惑行为素材，今天终于剪出来给大家看了！</p><p>经典场景一：明明碗里有粮，非要扒拉碗旁边地板上的那几颗。这是什么逻辑？</p><p>经典场景二：你刚换了新床单，它一定要第一个上去踩一遍。还要用那种"这是我的地盘"的眼神看着你。</p><p>经典场景三：凌晨三点突然在房间里百米冲刺，从客厅跑到卧室再跑回客厅，仿佛有什么看不见的东西在追它。</p><p>经典场景四：你工作的时候它一定要趴在键盘上，仿佛在说"别工作了，看看我"。</p><p>虽然这些行为让人哭笑不得，但这就是猫咪的可爱之处啊。你家猫主子有什么迷惑行为？评论区分享一下吧！</p>',
    tags: ['萌宠', '猫咪', '搞笑', '迷惑行为'],
    createdAt: '2026-07-30',
    featured: true,
  },
  {
    id: 9,
    title: '隐藏在北京胡同里的宝藏小店｜人均30吃到撑',
    slug: 'beijing-hutong-food',
    category: 'meishi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Beijing%20hutong%20alleyway%20with%20red%20lanterns%20and%20a%20small%20cozy%20restaurant%20entrance%2C%20steaming%20food%20visible%20through%20the%20window%2C%20warm%20evening%20atmosphere%2C%20cultural%20charm%2C%20lifestyle%20photography&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '07:40',
    views: 680000,
    likes: 58900,
    author: '吃货小分队',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20foodie%20holding%20chopsticks%2C%20excited%20expression%2C%20cream%20background%2C%20warm%20portrait%20lighting&width=100&height=100&seq=avatar-09&orientation=squarish',
    description: '北京胡同深处的隐藏美食，价格实惠味道绝了！',
    contentHtml: '<p>今天带大家探访一家藏在东四胡同里的宝藏小店，据说开了二十多年，附近的居民天天排队。</p><p>这家店没有招牌，门口只挂了一个红灯笼。推开木门进去，里面只有四张桌子，满满的烟火气。</p><p>必点招牌：老北京炸酱面。手擀面筋道十足，炸酱是老板娘自己熬的，肉丁大颗，酱香浓郁，配上黄瓜丝和豆芽，一碗下去满满的幸福感。价格只要15块！</p><p>还有他们家的卤煮火烧，汤汁浓郁，火烧吸满了汤汁，一口下去汁水四溅。老板说这个配方是爷爷传下来的。</p><p>最让我惊艳的是糖醋里脊，外酥里嫩，酸甜恰到好处，完全不输大饭店的水准。</p><p>两个人点了四个菜两碗面，结账才62块！这种良心小店真的不多了，强烈推荐给大家！</p>',
    tags: ['美食', '北京', '胡同', '探店'],
    createdAt: '2026-07-29',
    featured: false,
  },
  {
    id: 10,
    title: '当你把周杰伦的歌换成摇滚风格｜改编合集',
    slug: 'jay-chou-rock-cover',
    category: 'caiyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20electric%20guitar%20and%20amplifier%20in%20a%20dimly%20lit%20music%20studio%20with%20warm%20amber%20stage%20lighting%2C%20rock%20music%20atmosphere%2C%20creative%20energy%2C%20music%20photography%20style&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '06:10',
    views: 1500000,
    likes: 135000,
    author: '音乐玩家阿K',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20musician%20with%20cool%20style%2C%20cream%20background%2C%20creative%20portrait%2C%20warm%20lighting&width=100&height=100&seq=avatar-10&orientation=squarish',
    description: '周杰伦的经典歌曲如果变成摇滚风格，会是什么体验？',
    contentHtml: '<p>突发奇想，如果把周杰伦的经典歌曲全部改编成摇滚风格会怎样？说干就干！</p><p>第一首改编的是《七里香》。原曲温柔抒情，我把前奏改成了失真吉他的riff，副歌部分加入双踩鼓点，整首歌瞬间燃了起来。意想不到的是，这种改编竟然毫无违和感！</p><p>第二首挑战《双截棍》。这首歌本身节奏感就很强，加入金属风格的吉他solo和嘶吼唱腔后，直接变成了硬核摇滚。弹完之后手指都在发抖。</p><p>第三首是《稻香》。这首歌比较治愈，我就用了轻摇滚的风格，加入了木吉他和电吉他的对话，保留了原曲的温暖感但是多了一层力量。</p><p>音乐的魅力就在于无限的可能性，希望杰伦哥不要打我哈哈！你们还想听我改编哪首歌？</p>',
    tags: ['音乐', '周杰伦', '摇滚', '改编'],
    createdAt: '2026-07-28',
    featured: false,
  },
  {
    id: 11,
    title: '搞笑配音：当爸妈学会用表情包之后',
    slug: 'parents-using-memes',
    category: 'gaoxiao',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20middle%20aged%20Chinese%20couple%20looking%20at%20a%20smartphone%20with%20confused%20but%20amused%20expressions%2C%20living%20room%20setting%2C%20warm%20cozy%20lighting%2C%20humorous%20family%20scene%2C%20lifestyle%20photography&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '03:25',
    views: 2300000,
    likes: 205000,
    author: '搞笑配音师',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20funny%20young%20Chinese%20creator%20making%20a%20playful%20face%2C%20cream%20background%2C%20humorous%20portrait%2C%20warm%20lighting&width=100&height=100&seq=avatar-11&orientation=squarish',
    description: '爸妈用表情包的翻车现场，笑到肚子疼！',
    contentHtml: '<p>教爸妈用智能手机已经是地狱难度了，教他们用表情包简直是史诗级挑战！来看看这些翻车现场。</p><p>场景一：我妈在家族群里发了一个"微笑"表情，表示她很开心。但她不知道在年轻人的语境里，这个表情代表"呵呵，不想理你"。于是全群亲戚都不敢说话了。</p><p>场景二：我爸学会了发表情包，然后给我发了一个"为我们的友谊干杯"的中老年专属表情包，配文是"儿子，这个好可爱"。我看着那个闪闪发光的大字报风格，陷入了沉思。</p><p>场景三：我妈用我的表情包回我消息，但全用错了语境。我说"今晚不回家吃饭"，她回了一个"给你比心"……</p><p>虽然每次看到都笑到不行，但看着爸妈努力跟上时代的样子，心里还是挺暖的。</p>',
    tags: ['搞笑', '表情包', '爸妈', '日常'],
    createdAt: '2026-07-27',
    featured: true,
  },
  {
    id: 12,
    title: '养宠必看！狗狗分离焦虑症怎么破',
    slug: 'dog-separation-anxiety',
    category: 'dongwu',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cute%20golden%20retriever%20puppy%20looking%20at%20the%20camera%20with%20slightly%20worried%20eyes%2C%20sitting%20by%20a%20door%2C%20warm%20home%20interior%2C%20soft%20natural%20lighting%2C%20emotional%20pet%20photography%2C%20cream%20and%20beige%20tones&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '05:50',
    views: 450000,
    likes: 41200,
    author: '宠物医生小林',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20veterinarian%20in%20a%20white%20coat%2C%20professional%20and%20warm%2C%20cream%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-12&orientation=squarish',
    description: '出门狗狗就狂叫拆家？专业方法帮你解决分离焦虑。',
    contentHtml: '<p>很多铲屎官都有这个困扰：一出门狗狗就开始狂叫、拆家、随地大小便，回到家一片狼藉。这其实是典型的分离焦虑症。</p><p>首先我们要理解，狗狗是群居动物，独处会让它们感到恐惧。分离焦虑不是狗狗不乖，而是它们真的在害怕。</p><p>解决方法一：脱敏训练。从离开30秒开始，逐渐延长到1分钟、5分钟、半小时。每次回来不要过度兴奋地和狗狗互动，保持平静。</p><p>解决方法二：建立安全信号。每次出门前做同样的动作（比如拿钥匙、换鞋），但不要真的出门，让狗狗对这个信号不再敏感。</p><p>解决方法三：丰富独处环境。留下一些益智玩具、磨牙棒，或者播放轻柔的音乐，让独处时间不那么难熬。</p><p>严重的情况建议咨询专业宠物行为医生。请记住，耐心和爱是最好的药方。</p>',
    tags: ['萌宠', '狗狗', '养宠知识', '分离焦虑'],
    createdAt: '2026-07-26',
    featured: false,
  },
];